import React from 'react';
import PropTypes from 'prop-types';

function LinkComponent({ children }) {
  return <span>{children}</span>;
}

LinkComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default LinkComponent;
